/** Action column helpers for account disable / enable in dashboard tables. */

export const ACCOUNT_ACTION_COL = {
  key: '_action',
  label: '',
  sortable: false,
  filterable: false,
  className: 'data-table__actions',
};

export function accountDisableCell(login, onDisable) {
  return (
    <button
      type="button"
      className="account-action-btn account-action-btn--disable"
      onClick={() => onDisable(Number(login))}
      title="Hide this account from the dashboard"
    >
      Disable
    </button>
  );
}

export function accountEnableCell(login, onEnable) {
  return (
    <button
      type="button"
      className="account-action-btn account-action-btn--enable"
      onClick={() => onEnable(Number(login))}
      title="Show this account in the dashboard again"
    >
      Enable
    </button>
  );
}
